export default "__VITE_ASSET__7046cc7c__"